import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import CheckerStatus from "./status/CheckerStatus";

const MerchantDeletion = () => {
  const userRole = useSelector(
    (state) => state?.userAuth?.data?.role
  )?.toLowerCase();
  return userRole === "checker" ? (
    <CheckerStatus
      status="pending-deletion"
      title="Approve Merchants Deletion"
      action={true}
      actionsType="delete"
    />
  ) : (
    <Navigate to="/not-found" replace />
  );
};

export default MerchantDeletion;
